export enum ESmsRole {
  system = "system",
  user = "user",
  assistant = "assistant",
}

export const smsRoleAsString = (smsRole: ESmsRole | string): string => {
  switch (smsRole) {
    case ESmsRole.system:
      return "Système";
    case ESmsRole.user:
      return "Utilisateur";
    case ESmsRole.assistant:
      return "Assistant";
    default:
      return "Inconnu";
  }
};